import React, { Component } from "react";
import { FormGroup, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import classNames from "classnames";
import styles from "./CategoryRadio.scss";
import marketingIcon from "../../../../assets/images/marketing-icon.svg";
import financeIcon from "../../../../assets/images/finance-icon.svg";
import servicesIcon from "../../../../assets/images/creative-services-icon.svg";
import communicationsIcon from "../../../../assets/images/communications-icon.svg";
import corporateIcon from "../../../../assets/images/corporate-services-icon.svg";
import researchIcon from "../../../../assets/images/research-icon.svg";
import humanResourcesIcon from "../../../../assets/images/human-resources-icon.svg";
import marketingIconSelected from "../../../../assets/images/marketing-icon-selected.svg";
import financeIconSelected from "../../../../assets/images/finance-icon-selected.svg";
import servicesIconSelected from "../../../../assets/images/creative-services-icon-selected.svg";
import communicationsIconSelected from "../../../../assets/images/communications-icon-selected.svg";
import corporateIconSelected from "../../../../assets/images/corporate-services-icon-selected.svg";
import researchIconSelected from "../../../../assets/images/research-icon-selected.svg";
import humanResourcesIconSelected from "../../../../assets/images/human-resources-icon-selected.svg";

const icons = [
  marketingIcon,
  financeIcon,
  servicesIcon,
  communicationsIcon,
  corporateIcon,
  researchIcon,
  humanResourcesIcon
];

const iconsSelected = [
  marketingIconSelected,
  financeIconSelected,
  servicesIconSelected,
  communicationsIconSelected,
  corporateIconSelected,
  researchIconSelected,
  humanResourcesIconSelected
];

class CategoryRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: props.input.value || null
    };
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(value) {
    this.setState({ selected: value }, this.props.input.onChange(value));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      const value = nextProps.input.value;
      this.setState({ selected: value }, this.props.input.onChange(value));
    }
  }

  render() {
    const { input, groupName, options } = this.props;

    return (
      <FormGroup>
        <ToggleButtonGroup
          type="radio"
          name={groupName}
          defaultValue={input.value}
          className={styles.buttonGroup}
          vertical={true}
          onChange={this.handleOnChange}
        >
          {options &&
            options.map((item, index) => {
              return (
                <ToggleButton
                  value={item.id}
                  name={groupName}
                  className={classNames({
                    [styles.radio]: true,
                    [styles.active]: this.state.selected == item.id
                  })}
                  key={index}
                >
                  <div className={styles.radioContainer}>
                    <div className={styles.iconContainer}>
                      <img
                        src={
                          this.state.selected == item.id
                            ? iconsSelected[index]
                            : icons[index]
                        }
                      />
                    </div>
                    <div className={styles.textContainer}>
                      <div className={styles.categoryTitle}>{item.name}</div>
                      <div className={styles.categoryDesc}>
                        {item.description}
                      </div>
                    </div>
                  </div>
                </ToggleButton>
              );
            })}
        </ToggleButtonGroup>
      </FormGroup>
    );
  }
}

export default CategoryRadio;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/CategoryRadio.js